import request from '@/utils/httpRequest'

export default class AdjustService {
    queryById(id) {
        return request({
            url: '/finance/shyeFinanceReceivableAdjust/queryById',
            method: 'get',
            params: { id: id }
        })
    }

    list (params) {
        return request({
            url: '/finance/shyeFinanceReceivableAdjust/getDeratedList',
            method: 'get',
            params: params
        })
    }

    startFlow (params) {
        return request({
            url: '/finance/shyeFinanceReceivableAdjust/startFlow',
            method: 'post',
            data: params
        })
    }
}